import { Box } from "@mui/material";
import { useTiers } from "api/tiers";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { TierSetForm } from "./TierSetForm";
import { useStyles } from "./TierSetForm.styles";

export const EditTierSet = () => {
  const classes = useStyles();
  const { message } = useMessage();
  const { id: tierSetId } = useParams<{ id: string }>();

  const { useTierSetData } = useTiers();
  const { data: tierSetData } = useTierSetData(tierSetId as string);
  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: `${message({ id: "tierSet" })} ${tierSetData?.name || ""}`,
      path: links.tierSet(tierSetId),
    },
  };

  return (
    <>
      <TopHeader
        title={message({ id: "editTiersSet" })}
        breadcrumbs={breadcrumbs}
        clearLink={links.tierSet(tierSetId)}
      />
      <Box className={classes.formContainer}>
        <TierSetForm editMode={true} tierSetData={tierSetData} />
      </Box>
    </>
  );
};
